import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DTypeFormFileField } from '@grupo-constant/next-dtype/form';
import { DTypeViewableCol } from '@grupo-constant/next-dtype/types';
import { DTypeFormFieldComponent } from '../../dtype-field.model';

@Component({
    selector: 'multiimage-field-component',
    templateUrl: './multiimage-field.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DtypeMultiImageFieldComponent implements DTypeFormFieldComponent, OnInit {

    @Input() field: DTypeFormFileField;
    @Input() isUpdate: boolean;
    @Input() useSummaryView: boolean;

    constructor() { }

    ngOnInit() {
        const readonlyOnUpdate = (this.field.dTypeCol as DTypeViewableCol).readonlyOnUpdate;
        if (readonlyOnUpdate && this.isUpdate) {
            this.field.readonly = true;
        }
    }

}
